import { combineReducers } from '@reduxjs/toolkit';

import { persistReducer, createTransform } from 'redux-persist';
// reducer를 persist할 수 있게 해주는 persistReducer import
import persistStorage from 'redux-persist/lib/storage';

import user from 'redux/reducers/user';
import asset from 'redux/reducers/asset';
import storage from 'redux/reducers/storage';
import category from 'redux/reducers/category';
import script from 'redux/reducers/script';
import wkblScript from 'redux/reducers/wkblScript';
import library from 'redux/reducers/library';
import wkblVideo from 'redux/reducers/wkblVideo';
import wkblSpecialVideo from 'redux/reducers/wkblSpecialVideo';
import code from 'redux/reducers/code';
import modal from 'redux/reducers/modal';
import video from 'redux/reducers/video';
import preference from 'redux/reducers/preference';
import error from 'redux/reducers/error';
import notification from 'redux/reducers/notification';
import config from 'redux/reducers/config';
import download from 'redux/reducers/download';
import libraryNotification from 'redux/reducers/libraryNotification';
import statisticsPartial from 'redux/reducers/statisticsPartial';
import statisticsLogin from 'redux/reducers/statisticsLogin';
import statisticsDownload from 'redux/reducers/statisticsDownload';
import statisticsStreaming from 'redux/reducers/statisticsStreaming';
import statisticsAsset from 'redux/reducers/statisticsAsset';
import statisticsStorage from './statisticsStorage';
import statisticsLog from './statisticsLog';
import aws from './aws';

export const rootReducer = combineReducers({
  user,
  asset,
  storage,
  category,
  wkblScript,
  script,
  library,
  video,
  wkblVideo,
  wkblSpecialVideo,
  modal,
  code,
  preference,
  error,
  notification,
  config,
  download,
  libraryNotification,
  statisticsPartial,
  statisticsAsset,
  statisticsLogin,
  statisticsDownload,
  statisticsStreaming,
  statisticsStorage,
  statisticsLog,
  aws
});

// const SetTransform = createTransform(
//   // transform state on its way to being serialized and persisted.
//   (inboundState: LibraryState, key) => {
//     // convert mySet to an Array.
//     // console.log({ inboundState, key });
//     return {
//       ...inboundState,
//     };
//   },
//   // transform state being rehydrated
//   (outboundState, key) => {
//     // convert mySet back to a Set.
//     // console.log({ outboundState, key });
//     return { ...outboundState };
//   },
//   // define which reducers this transform gets called for.
//   { whitelist: ['library'] },
// );

const persistConfig = {
  // 새로운 persist config를 선언해준다.
  key: 'root',
  // reducer 객체의 어느 지점에서 부터 데이터를 저장할 것인지 설정해주는것이 key이다.
  // root부터 시작한다고 지정해준다.
  storage: persistStorage,
  // 위에 import 한 성격의 storage를 지정해준다. 이 예제의 경우에는 localstorage
  whitelist: ['libraryNotification'],
  // 유지 및 보존하고 싶은 데이터를 배열안에 지정해준다.
  // string 형태이고 아래 combineReducers에 지정된 값들을 사용해주면 된다.
  // transforms: [SetTransform],
};

export default persistReducer(persistConfig, rootReducer);
